import { useAuth } from 'react-oidc-context';

// ----------------------------------------------------------------------

export function useAuthContext() {
  const auth = useAuth();

  return auth;
}
